export const PAYMENT_DONE_MESSAGE = "COMFORTKINO_PAYMENT_DONE"

/** Return URL банка после оплаты картой (см. App\PaymentController). */
export const PAYMENT_RETURN_BLANK_URL = "https://api.comfortkino.ru/blank.html"

export const PAYMENT_RETURN_ORIGINS = [
    "https://api.comfortkino.ru",
    "https://api.comfkino.ru",
] as const

export type PaymentDoneMessage = {
    type: typeof PAYMENT_DONE_MESSAGE
    orderId?: string | null
}

export function openCardPaymentWindow(url: string): Window | null {
    return window.open(
        url,
        "comfortkino_card_payment",
        "noopener,noreferrer,width=520,height=720,resizable=yes,scrollbars=yes",
    )
}

export function isPaymentDoneMessage(data: unknown): data is PaymentDoneMessage {
    return (
        typeof data === "object" &&
        data !== null &&
        "type" in data &&
        (data as PaymentDoneMessage).type === PAYMENT_DONE_MESSAGE
    )
}

export function isPaymentReturnOrigin(origin: string): boolean {
    return (PAYMENT_RETURN_ORIGINS as readonly string[]).includes(origin)
}

export function isPaymentReturnUrl(url: string | null | undefined): boolean {
    if (!url) return false
    return (
        url.startsWith(PAYMENT_RETURN_BLANK_URL) ||
        url.startsWith("https://api.comfkino.ru/blank.html")
    )
}

/** blank.html или chrome-error при X-Frame-Options: DENY на return URL. */
export function isLikelyPaymentReturnHref(url: string | null | undefined): boolean {
    if (!url) return false
    if (isPaymentReturnUrl(url)) return true
    return url.startsWith("chrome-error://")
}

/** Пытается прочитать текущий URL iframe/popup. Cross-origin → null. */
export function readFrameHref(frame: Window | null | undefined): string | null {
    if (!frame) return null
    try {
        return frame.location.href
    } catch {
        return null
    }
}

export function frameIsOnPaymentReturn(frame: Window | null | undefined): boolean {
    return isLikelyPaymentReturnHref(readFrameHref(frame))
}

/** Иногда родитель видит blank.html в Resource Timing после редиректа банка. */
export function performanceSawPaymentReturn(): boolean {
    try {
        return performance
            .getEntriesByType("resource")
            .some(entry => isPaymentReturnUrl(entry.name) || entry.name.includes("/blank.html"))
    } catch {
        return false
    }
}
